// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__10ryJ","filesListContainer":"PosDisputesFiles_filesListContainer__2Q2yt","filesButton":"PosDisputesFiles_filesButton__1Iz6m"};